// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { GeneralSettings } from "../../../Utils/GeneralSettings/GeneralSettings.js";
import { DateTimeConvertor } from "../../../Utils/Time/DateTimeConvertor.js";
import { DateTimeUtils } from "../../../Utils/Time/DateTimeUtils.js";
import { BaseItem } from "../../cache/BaseItem.js";
import { ColumnParams } from "../../cache/ColumnParams.js";
import { QuickTableColumnType } from "../../elements/QuickTable/QuickTableMisc.js"

export let MultiTimeSalesItem = function (sessionSettings)
{
    BaseItem.call(this, sessionSettings)
    this.ItemId = null
    this.instrument = null
    this.price = null
    this.time = null
    this.size = null
}

MultiTimeSalesItem.prototype = Object.create(BaseItem.prototype)


MultiTimeSalesItem.prototype.ColumnCount = function ()
{
    return MultiTimeSalesItem.columnsParams.length
}

MultiTimeSalesItem.prototype.getColumnData = function (column)
{
    let val = this.getColumnValue(column)
    let fVal = null
    let ins = this.instrument
    let sess = this.sessionSettings

    switch (column)
    {
        case 1:
            fVal = DateTimeUtils.formatDate(val, 'HH:mm:ss')
            break
        case 2:
            fVal = ins.formatPrice(val)
            break
        case 3:
            fVal = ins.DataCache.formatVolume(ins, val, GeneralSettings.View.displayAmountInLots())
            break
        default:
            fVal = val === null || val === undefined ? '' : val.toString()
    }

    return { Value: val, FormattedValue: fVal }
}

MultiTimeSalesItem.prototype.getColumnValue = function (column)
{
    let sess = this.sessionSettings
    let ins = this.instrument
    let dc = ins.DataCache

    switch (column)
    {
        case 0:
            return ins.DisplayName()
        case 1:
            return DateTimeConvertor.ConvertUTCTimeToSelectedTimeZone(this.time, dc)
        case 2:
            return this.price
        case 3:
            return this.size
        default:
            return ''
    }
}

MultiTimeSalesItem.prototype.GetColumnParams = function (column)
{
    return MultiTimeSalesItem.columnsParams[column]
}

MultiTimeSalesItem.columnsParams = [
    /*0*/new ColumnParams('panel.timeSales.Instrument', 70, 0, false, true, false),
    /*1*/new ColumnParams('panel.timeSales.Time', 70, QuickTableColumnType.COL_DATE_SORT, false, true, false),
    /*2*/new ColumnParams('panel.timeSales.Price', 70, QuickTableColumnType.COL_SIMPLE_NUMERIC, false, true, false),
    /*3*/new ColumnParams('panel.timeSales.Size', 70, QuickTableColumnType.COL_SIMPLE_NUMERIC, false, true, false),
]
